import { useOffline } from "../lib/offline-context.js";
import type { Toast } from "../lib/offline-context.js";

const VARIANTS: Record<
  Toast["kind"],
  { className: string; label: string }
> = {
  success: {
    className: "border-emerald-300 bg-emerald-50 text-emerald-900",
    label: "Succès",
  },
  info: {
    className: "border-slate-300 bg-slate-50 text-slate-900",
    label: "Info",
  },
  error: {
    className: "border-red-300 bg-red-50 text-red-900",
    label: "Erreur",
  },
};

export function SyncToasts() {
  const { toasts, dismissToast } = useOffline();
  if (toasts.length === 0) return null;
  return (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map((t) => {
        const v = VARIANTS[t.kind];
        return (
          <div
            key={t.id}
            role="status"
            className={`rounded-md border shadow-md px-3 py-2 text-sm ${v.className}`}
          >
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0 break-words">{t.message}</div>
              <button
                onClick={() => dismissToast(t.id)}
                className="text-xs px-1 opacity-70 hover:opacity-100"
                aria-label="Fermer"
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
